import { authHeader } from '@/_helpers'

export const clientBookingSignalService = {
  getBookingSignals,
  createBookingSignal,
  deactivateBookingSignal,
}

const apiUrl = process.env.VUE_APP_ROOT_API

function getBookingSignals(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const params = new URLSearchParams({ client_id: String(clientId) })
  return fetch(
    `${apiUrl}/clients/client-booking-signals?${params.toString()}`,
    requestOptions,
  ).then(handleResponse)
}

function createBookingSignal(model) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(model),
  }
  return fetch(`${apiUrl}/clients/client-booking-signal`, requestOptions).then(
    handleResponse,
  )
}

function deactivateBookingSignal(clientId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id: clientId }),
  }
  return fetch(
    `${apiUrl}/clients/client-booking-signal-deactivate`,
    requestOptions,
  ).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
